import { callReport, heldRoom } from "@shared/media";
import { startTelemetry, telemetryEvent, telemetryMeasurement } from "@shared/telemetry";
import { Track } from "livekit-client";

/** Samples diagnostics; never opens a microphone or changes media constraints. */
export function holdTelemetry(): void {
  if (!startTelemetry()) return;
  let sampling = false;
  let previousRoom: string | undefined;
  const timer = window.setInterval(async () => {
    const room = heldRoom();
    if (room?.name !== previousRoom) {
      telemetryEvent(room ? "call.connected" : "call.disconnected");
      previousRoom = room?.name;
    }
    if (!room || sampling) return;
    sampling = true;
    try {
      for (const report of await callReport()) {
        if (heldRoom() !== room) break;
        const values: Record<string, number> = {};
        for (const [key, value] of Object.entries({ bitrate_kbps: report.kbps, loss_percent: report.lost,
          jitter_ms: report.jitterMs, rtt_ms: report.rttMs, concealed_percent: report.concealed })) {
          if (value !== null) values[key] = value;
        }
        telemetryMeasurement("webrtc_audio", values, {
          direction: report.who === "мы" ? "outbound" : "inbound", codec: report.codec ?? "unknown",
        });
      }
      const participants = [room.localParticipant, ...room.remoteParticipants.values()];
      for (const participant of participants) {
        const track = participant.getTrackPublication(Track.Source.ScreenShare)?.videoTrack;
        const stats = await track?.getRTCStatsReport();
        stats?.forEach((entry) => {
          if (entry.type !== "inbound-rtp" && entry.type !== "outbound-rtp") return;
          const values: Record<string, number> = {};
          for (const key of ["framesPerSecond", "frameWidth", "frameHeight", "jitter", "freezeCount"]) {
            if (typeof entry[key] === "number") values[key] = entry[key];
          }
          telemetryMeasurement("webrtc_video", values, {
            direction: entry.type, quality_limitation: String(entry.qualityLimitationReason ?? "unknown"),
          });
        });
      }
    } catch {
      // Tracks can disappear during disconnect. Don't turn this into an error storm.
    } finally { sampling = false; }
  }, 15_000);
  if (import.meta.hot) import.meta.hot.dispose(() => window.clearInterval(timer));
}
